export default {
  SETTINGS_CHANGE_PASSWORD_POST_REQUEST:
    "SETTINGS_CHANGE_PASSWORD_POST_REQUEST",
  SETTINGS_CHANGE_PASSWORD_POST_RECEIVE:
    "SETTINGS_CHANGE_PASSWORD_POST_RECEIVE",
  SETTINGS_CHANGE_PASSWORD_POST_ERROR: "SETTINGS_CHANGE_PASSWORD_POST_ERROR",
  SETTINGS_UPDATE_CHANGE_PASSWORD_MESSAGE:
    "SETTINGS_UPDATE_CHANGE_PASSWORD_MESSAGE"
};
